import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "ghippo-header" }
const _hoisted_2 = { class: "ghippo-header-aside_wrapper" }
const _hoisted_3 = { class: "ghippo-header-aside" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "ghippo-toolbox" }
const _hoisted_6 = { class: "ghippo-toolbox-item" }
const _hoisted_7 = { class: "ghippo-toolbox-item" }
const _hoisted_8 = { class: "ghippo-toolbox-item" }
const _hoisted_9 = { class: "ghippo-message-count-box" }
const _hoisted_10 = { class: "ghippo-message-count" }
const _hoisted_11 = { class: "ghippo-toolbox-item" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = { class: "ghippo-user-avatar ghippo-user-username" }
const _hoisted_14 = {
  key: 0,
  class: "ghippo-sub-account-manage"
}

import { i18n } from '@/plugins';
import {
  computed, ref, type PropType,
} from 'vue';
import { noop } from '@vueuse/core';
import AnakinHeaderButton from '@/components/AnakinHeaderButton.vue';
import { useGlobalStore } from '@/stores';
import logout from '@/utils/logout';
import {
  Message,
} from '@daocloud-proto/ghippo/v1alpha1/message.pb';
import { TopNavResponse } from '@daocloud-proto/ghippo/v1alpha1/topnav.pb';
import MessageBox from '@/components/MessageBox.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import { simpleErrorNoty } from '@/utils/noty';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnakinHeader',
  props: {
  portalUrl: {
    type: String as PropType<string>,
    default: '',
  },
  isCsp: {
    type: Boolean,
    default: false,
  },
  showSubAccount: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const globalStore = useGlobalStore();

const navConfig = computed<TopNavResponse>(() => globalStore.navConfig);

const user = computed(() => ({
  username: globalStore.username,
  avatar: '',
}));

const userOperation = computed(() => {
  const arr = [
    {
      label: i18n.t('components.AnakinHeader.user.personal-center'),
      icon: 'icon-user',
      href: './ghippo/profile',
      operate: noop,
    },
    {
      label: i18n.t('components.AnakinHeader.user.subAccount'),
      slotId: 'sub-account',
      icon: 'icon-user-group',
      href: './ghippo/sub-accounts',
      operate: noop,
      meta: {
        showSubAccount: true,
      },
    },
    {
      label: i18n.t('components.AnakinHeader.user.control'),
      icon: 'icon-user-settings',
      href: './ghippo/users',
      operate: noop,
      meta: {
        csp: false,
      },
    },
    {
      label: i18n.t('components.AnakinHeader.user.setting'),
      icon: 'icon-setting',
      href: './ghippo/settings',
      operate: noop,
      meta: {
        csp: false,
      },
    },
    {
      label: i18n.t('components.AnakinHeader.user.logout'),
      icon: 'icon-logout',
      operate: () => {
        logout(true);
      },
    },
  ];

  return arr.filter((v) => !(v.meta?.csp === false && props.isCsp))
    .filter((v) => !v.meta?.showSubAccount || props.showSubAccount);
});

const isGl = computed(() => globalStore.noticeUnread > 99);

const messageRef = ref<InstanceType<typeof MessageBox> | null>(null);

const fetchMessageCounts = async () => {
  try {
    const { unreadTotal = 0 } = await Message.GetMessagesCount({});

    globalStore.setNoticeUnread(unreadTotal);
  } catch (e) {
    simpleErrorNoty(e, {
      name: i18n.t('components.AnakinHeader.count'),
    });
  }
};

fetchMessageCounts();

const emitDrawer = () => {
  messageRef.value?.openDrawer();
  messageRef.value?.fetchMessagesList();
};


return (_ctx: any,_cache: any) => {
  const _component_dao_history_link = _resolveComponent("dao-history-link")!
  const _component_dao_icon = _resolveComponent("dao-icon")!
  const _component_dao_dropdown_item = _resolveComponent("dao-dropdown-item")!
  const _component_dao_dropdown_menu = _resolveComponent("dao-dropdown-menu")!
  const _component_dao_dropdown = _resolveComponent("dao-dropdown")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_unref(navConfig).icon)
        ? (_openBlock(), _createBlock(_component_dao_history_link, {
            key: 0,
            class: "ghippo-header-logo",
            href: __props.portalUrl
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "ghippo-header-logo-img",
                src: _unref(navConfig).icon,
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["href"]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "top-nav"),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(AnakinHeaderButton, {
          type: "link",
          href: __props.isCsp
            ? _ctx.$t('common.drunDocsLink', { link : 'contact/index.html'})
            : 'https://github.com/DaoCloud/DaoCloud-docs/issues'
          ,
          target: "_blank",
          "tooltip-content": _ctx.$t('components.AnakinHeader.feedback'),
          class: "ghippo-icon-trigger"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dao_icon, {
              "use-font": "",
              name: "icon-feedback",
              class: "ghippo-operate-icon"
            })
          ]),
          _: 1
        }, 8, ["href", "tooltip-content"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(AnakinHeaderButton, {
          type: "link",
          href: __props.isCsp
            ? _ctx.$t('common.drunDocsLink', { link : ''})
            : _ctx.$t('common.docLink', { link: 'dce/what/' }),
          "tooltip-content": _ctx.$t('components.AnakinHeader.help'),
          target: "_blank",
          class: "ghippo-icon-trigger"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dao_icon, {
              "use-font": "",
              name: "icon-unknow",
              class: "ghippo-operate-icon"
            })
          ]),
          _: 1
        }, 8, ["href", "tooltip-content"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(AnakinHeaderButton, {
          class: "ghippo-icon-trigger",
          "tooltip-content": _ctx.$t('components.AnakinHeader.messages'),
          onClick: emitDrawer
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dao_icon, {
              "use-font": "",
              name: "icon-bell",
              class: "ghippo-operate-icon"
            }),
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(isGl) ? '99+' : _unref(globalStore).noticeUnread), 1)
            ], 512), [
              [_vShow, _unref(globalStore).noticeUnread !== 0]
            ])
          ]),
          _: 1
        }, 8, ["tooltip-content"]),
        _createVNode(MessageBox, {
          ref_key: "messageRef",
          ref: messageRef
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_dao_dropdown, {
          trigger: "click",
          offset: 5
        }, {
          menu: _withCtx(() => [
            _createVNode(_component_dao_dropdown_menu, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userOperation), (operate) => {
                  return (_openBlock(), _createBlock(_component_dao_dropdown_item, {
                    key: operate.label,
                    onClick: operate.operate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_dao_history_link, {
                        href: operate.href,
                        icon: operate.icon,
                        class: "ghippo-user-drop--item"
                      }, {
                        default: _withCtx(() => [
                          (operate.slotId === 'sub-account')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("span", null, _toDisplayString(operate.label), 1),
                                _createVNode(SvgIcon, {
                                  name: "new",
                                  class: "new-icon"
                                })
                              ]))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(operate.label), 1)
                              ], 64))
                        ]),
                        _: 2
                      }, 1032, ["href", "icon"])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(AnakinHeaderButton, { class: "ghippo-user-trigger" }, {
              default: _withCtx(() => [
                (!_unref(user).avatar)
                  ? (_openBlock(), _createBlock(_component_dao_icon, {
                      key: 0,
                      "use-font": "",
                      name: "icon-user-avatar",
                      class: "ghippo-user-avatar ghippo-user-default-avatar"
                    }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _unref(user).avatar,
                      alt: _unref(user).username
                    }, null, 8, _hoisted_12)),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(user).username), 1),
                _createVNode(_component_dao_icon, {
                  "use-font": "",
                  name: "icon-dropdown-line",
                  class: "ghippo-user-drop-icon"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})